import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import PageContainer from '@/components/Container/PageContainer';
import { Button } from '@/components/UI/Button';
import { Card, Notice } from './styles';
import { getSignatureV2ApiError } from './workflowState';
import { openInvitedSigningEntry } from './signingEntry';

export default function SignatureV2SigningPage() {
  // @ts-ignore i18next 的深層 key 型別超過 CRA 編譯器限制，沿用相鄰頁面處理。
  const { t } = useTranslation();
  const { workflowId = '' } = useParams();
  const [params] = useSearchParams();
  const step = params.get('step');
  const [attempt, setAttempt] = useState(0);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    setError('');
    // 延至下一個 task，避免 React StrictMode 的試掛載重複兌換。
    const timer = window.setTimeout(() => {
      openInvitedSigningEntry(workflowId, step).then((ticket) => {
        if (active) window.location.assign(ticket.entry_url);
      }).catch((reason) => {
        if (!active) return;
        const code = reason instanceof Error && ['invitation_invalid', 'signing_entry_not_actionable', 'signing_entry_forbidden'].includes(reason.message)
          ? reason.message : getSignatureV2ApiError(reason).code;
        setError(code || 'generic');
      });
    }, 0);
    return () => { active = false; window.clearTimeout(timer); };
  }, [workflowId, step, attempt]);

  const translate = t as unknown as (key: string, options?: Record<string, unknown>) => string;
  return (
    <PageContainer title={t('signatureV2.invitation.title')}>
      <Card>
        {error ? <>
          <Notice danger role="alert">{translate(
            ['signing_entry_forbidden', 'signature_v2_forbidden'].includes(error)
              ? 'signatureV2.signingEntry.wrongAccount' : `signatureV2.errors.${error}`,
            { defaultValue: t('signatureV2.errors.generic') }
          )}</Notice>
          <Button type="button" variant="primary" onClick={() => setAttempt((value) => value + 1)}>{t('signatureV2.actions.retry')}</Button>
          <Link to={`/signature-v2/workflows/${workflowId}`}>{t('signatureV2.actions.openWorkflow')}</Link>
        </> : <Notice role="status">{t('signatureV2.invitation.opening')}</Notice>}
      </Card>
    </PageContainer>
  );
}
